(function ($) {
    $(document).ready(function () {
        $('.modal').each(function(){
            const $this = $(this);
            const id = $this.attr('id');
            $('a[href="#' +id+'"]').attr('data-toggle', 'modal');
        })
    });
})(jQuery);